import Button from '../../../../components/Button'
import FlexLayout from 'src/components/FlexLayout'
import { fractionTableHeadersList } from '../../FractionUtils'
import Table from '../../../../components/Table'
import Text from '../../../../components/Text'
import { Batch, FractionItem } from '../../FractionTypes'
import { weightFormatter } from 'src/utils'

interface FractionTableProps {
  table: FractionItem[];
  batch: Batch;
  finishAction?: () => Promise<void>;
  totalFractioned?: number;
}

const FractionTable = ({
  table,
  batch,
  finishAction,
  totalFractioned,
}: FractionTableProps): JSX.Element =>
  (table.length > 0 ? (
    <FlexLayout
      direction='column'
      align='center'
      style={{
        overflowY: 'auto',
        maxHeight: '500px',
        margin: '30px 0 0 0',
      }}
    >
      <Text
        plainText={(
          <>
            <strong>Total de Frações: </strong>
            <span>{table.length}</span>
          </>
        )}
      />
      <Text
        plainText={(
          <>
            <strong>Total Fracionado: </strong>
            <span>
              {`${weightFormatter(totalFractioned?.toFixed(3))} kilo(s)`}  {batch.is_kg && `de ${weightFormatter(batch.quantidade_total! * 1000)} kilo(s)`}
            </span>
          </>
        )}
      />
      <Table
        headers={fractionTableHeadersList}
        initData={table}
        style={{ margin: '20px 0 0 0', overflowY: 'auto' }}
      />
      <Button
        type='button'
        testId='fraction-finish-button'
        text='fraction.form.finish'
        style={{ width: '200px' }}
        onClick={finishAction}
      />
    </FlexLayout>
  ) : (
    <></>
  ))

export default FractionTable
